import React, {useContext, useEffect, useState} from 'react'
import {Container, List} from '@material-ui/core'
import {useHistory} from 'react-router'
import I18nContext from '../../../services/I18n/I18nContext'
import servicesData from '../../../services/data/services.json'
import incentivesData from '../../../services/data/incentives.json'
import IServices from '../../../interfaces/IServices'
import ServiceCategoryItem from './components/ServiceCategoryItem'
import useStyles from './ServicesStyles'
import {ActionData, QuoteAction, QuoteContext} from '../../../services/quote/QuoteProvider'
import SetupInfoPopup from '../../common/SetupInfoPopup/SetupInfoPopup'
import BusinessTypeSwitch, {BUY_BUSINESS_TYPE, INCENTIVE_BUSINESS_TYPE, RENT_BUSINESS_TYPE } from '../../common/BusinessTypeSwitch/BusinessTypeSwitch';
import IService from '../../../interfaces/IService'
import { useIsMount } from '../../../utils/hooks/useIsMount'
import {currency} from './components/ServiceItem';
import {getGoogleTagItems} from '../../../utils/helpers/helpers';

const additionalServiceRentDesc = "Aktivaciju najma uređaja, trajno jamstvo, popunjavanje zahtjeva i ugovora za dobivanje Fina certifikata, \n" +
    "online generiranje i učitavanje certifikata, učitavanje Vašeg cjenika, izrađivanje Internog akta, odluke o blagajničkom  \n" +
    "maksimumu, podešavanje potrebnih postavki sustava te isporuku potpuno spremne blagajne na odabranu lokaciju. \n"

const deviceRentDesc = "<strong>Minimalno korištenje 12 mjeseci.</strong>"

const Services = () => {
    const {translate} = useContext(I18nContext)
    const classes = useStyles()
    const history = useHistory()
    const {dispatch, quote} = useContext(QuoteContext)
    const [filteredServiceData, setFilteredServiceData] = useState(servicesData)
    const options = servicesData.find(s => s.id === 'options') as IServices
    const setupOption = options?.data.find((o): boolean => o.id === 'option3')

    const isMount = useIsMount();

    useEffect(() => {
        if(!isMount) return;
        window.dataLayer.push({ ecommerce: null })
        window.dataLayer.push({
            event: "view_item",
            ecommerce: {
                currency: currency,
                value: quote.totalFixed === 0 ? quote.totalMonthly : quote.totalFixed,
                items: getGoogleTagItems(quote)
            }
        })
        // eslint-disable-next-line
    }, [isMount])

    const addItem = (data: ActionData) => {
        if(data.id === 'option2') { // If "Internet opcija" selected update quantity with device quantity
            const device = quote.items.find((i: IService) => i.id === 'device_one')
            data.quantity = !!device ? device.quantity : data.quantity
        }

        if(data.id === 'device_one' && quote.businessType !== INCENTIVE_BUSINESS_TYPE) {
            const serviceDataCopy = JSON.parse(JSON.stringify(servicesData));
            const internetOptionCopy: ActionData = serviceDataCopy[2].data[0];

            dispatch({
                data: internetOptionCopy,
                type: QuoteAction.removeItem,
            })

            internetOptionCopy.previousPrice = 4.99
            internetOptionCopy.price = 0
            internetOptionCopy.fixedPrice = 0
            internetOptionCopy.quantity = data.quantity
            internetOptionCopy.preselected = true

            dispatch({
                data: internetOptionCopy,
                type: QuoteAction.addItem,
            })
        
            setFilteredServiceData(serviceDataCopy);
        }

        dispatch({
            data,
            type: QuoteAction.addItem,
        })
    }

    const removeItem = (data: ActionData) => {
        if(data.id === 'device_one' && quote.businessType === BUY_BUSINESS_TYPE) { // 
            const serviceDataCopy = JSON.parse(JSON.stringify(servicesData));
            const internetOptionCopy: ActionData = serviceDataCopy[2].data[0];

            dispatch({
                data: internetOptionCopy,
                type: QuoteAction.removeItem,
            })
        
            setFilteredServiceData(serviceDataCopy);
        }

        dispatch({
            data,
            type: QuoteAction.removeItem,
        })
    }

    const changeItem = (data: ActionData) => {
        dispatch({
            data,
            type: QuoteAction.changeItem,
        })
    }

    const closeSetupInfoPopup = () => {
        dispatch({
            data: {showSetupInfoPopup: false} as ActionData,
            type: QuoteAction.setShowSetupInfoPopup,
        })
        window.scrollTo({ top: 0 });
        history.push('/form')
    }

    const handleBusinessTypeChange = (businessType: string) => {
        dispatch({
            data: {businessType} as ActionData,
            type: QuoteAction.setBusinessType,
        })
    }

    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const type = urlParams.get('type')
        const businessType = type === 'poticaji' ? INCENTIVE_BUSINESS_TYPE : (type === 'najam' ?  RENT_BUSINESS_TYPE : BUY_BUSINESS_TYPE)

        if (type) handleBusinessTypeChange(businessType)
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        const serviceDataCopy = JSON.parse(JSON.stringify(servicesData)); //Deep clone
        const incentivesDataCopy = JSON.parse(JSON.stringify(incentivesData));

        let deviceQuantity = quote.items.find((i: IService) => i.id === 'device_one')?.quantity
        // Initial device object
        const device = serviceDataCopy[1].data.find((i: IService) => i.id === 'device_one')

        const additionalService = serviceDataCopy[2].data.find((i: IService) => i.id === 'option3')

        const internetOption = serviceDataCopy[2].data.find((i: IService) => i.id === 'option2')

        const basicService = serviceDataCopy[0].data.find((i: IService) => i.id === 'basicService1')

        const incentive1 = incentivesDataCopy[0].data.find((i: IService) => i.id === 'incentive_1')

        const incentive2 = incentivesDataCopy[1].data.find((i: IService) => i.id === 'incentive_2')

        if (!isMount) {
            removeItem({...additionalService, quantity: 0})
            removeItem({...device, quantity: 0})
            removeItem({...basicService, quantity: 0})
            removeItem({...incentive1, quantity: 0})
            removeItem({...incentive2, quantity: 0})
            removeItem({...internetOption, quantity: 0})
        }

        if (quote.businessType === RENT_BUSINESS_TYPE) {
            additionalService.title = "Aktivacija i postavljanje sustava za rad"
            additionalService.description = additionalServiceRentDesc
            additionalService.price = 49.00
            additionalService.auto_code = 68
            const addedService = {...additionalService, preselected: true} as IService
            serviceDataCopy[1].data = [
                ...serviceDataCopy[1].data,
                addedService
            ]

            device.price = 9.99
            device.monthlyService = true
            device.preselected = true
            device.description = `${device.description} ${deviceRentDesc}`
            delete device.previousPrice

            deviceQuantity = (deviceQuantity && deviceQuantity > 0) ? deviceQuantity : 1

            // Remove option3 from data
            serviceDataCopy[2].data = serviceDataCopy[2].data.filter((i: IService) => i.id !== 'option3')

            /* Set changes for device */
            changeItem({...device, quantity: deviceQuantity || 0})

            addItem({...basicService, quantity: 1})
            addItem({...additionalService, quantity: 1})
            addItem({...device, quantity: deviceQuantity})

            /* Internet option -> 2 months free */
            internetOption.previousPrice = 4.99
            internetOption.price = 0
            internetOption.fixedPrice = 0
            internetOption.quantity = device.quantity
            internetOption.preselected = true
            internetOption.note = "2 mjeseca gratis uz najam uređaja. Nakon 2 mjeseca plaća se 4,99 €/mj"

            setFilteredServiceData(serviceDataCopy)

        } else if(quote.businessType === BUY_BUSINESS_TYPE) {

            /* Change device price and remove monthly service flag because BUY BUSINESS TYPE is selected */
            device.previousPrice = 289.00
            device.price = 239.00
            device.preselected = false
            device.monthlyService = false

            additionalService.auto_code = 70
            /* Set changes for additional service */
            changeItem({...additionalService, auto_code: 70, quantity: 1})

            /* Set changes for device */
            changeItem({...device, quantity: deviceQuantity || 0})

            addItem({...basicService, quantity: 1})

            setFilteredServiceData(serviceDataCopy)
        } else {
            setFilteredServiceData(incentivesData);
        }


        // eslint-disable-next-line
    }, [quote.businessType])

    return (
        <Container className={classes.root}>
            <h1 className={classes.rootTitle}>{translate('title')}</h1>
            <div className={classes.alignCenter} style={{marginTop: '65px'}}>
                <BusinessTypeSwitch businessType={quote.businessType} handleChange={handleBusinessTypeChange}/>
            </div>
            <List>
                {
                    (filteredServiceData as IServices[]).map((serviceCategory, index) => {
                        const hideServiceNumber = quote.businessType === INCENTIVE_BUSINESS_TYPE;
                        return (
                            <ServiceCategoryItem key={`serviceCategoryItem${index}`}
                                                 serviceNumber={hideServiceNumber ? null : index + 1}
                                                 quote={quote}
                                                 data={serviceCategory}
                                                 addItem={addItem}
                                                 changeItem={changeItem}
                                                 removeItem={removeItem}/>
                        )
                    })
                }
            </List>
            {(quote.showSetupInfoPopup && setupOption) && <SetupInfoPopup option={setupOption} addItem={addItem} close={closeSetupInfoPopup}/>}
        </Container>
    )
}

export default Services
